import { render, staticRenderFns } from "./addGroupSidebar.vue?vue&type=template&id=3b4cbed6&scoped=true&"
import script from "./addGroupSidebar.vue?vue&type=script&lang=js&"
export * from "./addGroupSidebar.vue?vue&type=script&lang=js&"
import style0 from "./addGroupSidebar.vue?vue&type=style&index=0&id=3b4cbed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4cbed6",
  null
  
)

export default component.exports